const language = globalThis.navigator?.language ?? "en";

export const numberFormatter = Intl.NumberFormat(language, { notation: "compact", compactDisplay: "short" });

export const percentageFormatter = Intl.NumberFormat(language, {
  minimumIntegerDigits: 1,
  maximumFractionDigits: 0,
});

export const asPixels = (value: number) => `${value}px`;
